const menu = {
	list() {
		return [
			// 管理员角色菜单配置
			{
				backMenu: [
					{
						menu: "运营管理",
						child: [
							{
								appFrontIcon: "cuIcon-news",
								buttons: ["新增", "查看", "修改", "删除"],
								menu: "新闻公告",
								tableName: "news"
							},
							{
								appFrontIcon: "cuIcon-flashlightopen",
								buttons: ["新增", "查看", "修改", "删除"],
								menu: "轮播图管理",
								tableName: "config"
							},
							{
								appFrontIcon: "cuIcon-service",
								buttons: ["新增", "查看", "修改", "删除"],
								menu: "平台信息管理",
								tableName: "info"
							},
							{
								appFrontIcon: "cuIcon-rank",
								buttons: ["新增", "查看", "修改", "删除"],
								menu: "用户管理",
								menuJump: "列表",
								tableName: "yonghu"
							},
							{
								appFrontIcon: "cuIcon-check",
								buttons: ["新增", "查看", "修改", "删除"],
								menu: "药品经营资质",
								menuJump: "列表",
								tableName: "qualification"
							}


						]
					},
					// 产品分类管理
					{
						menu: "产品分类管理",
						child: [
							{
								appFrontIcon: "cuIcon-present",
								buttons: ["新增", "查看", "修改", "删除"],
								menu: "产品分类",
								menuJump: "列表",
								tableName: "chanpinfenlei"
							}
						]
					},

					// 热销药品管理
					{
						menu: "热销药品管理",
						child: [
							{
								appFrontIcon: "cuIcon-addressbook",
								buttons: ["新增", "查看", "修改", "删除", "查看评论"],
								menu: "热销药品",
								menuJump: "列表",
								tableName: "rexiaonongchanpin"
							}
						]
					},



					// 订单管理
					{
						menu: "订单管理",
						child: [
							{
								appFrontIcon: "cuIcon-copy",
								buttons: ["删除", "查看"],
								menu: "已取消订单",
								tableName: "orders/已取消"
							},
							{
								appFrontIcon: "cuIcon-circle",
								buttons: ["查看", "删除"],
								menu: "已退款订单",
								tableName: "orders/已退款"
							},
							{
								appFrontIcon: "cuIcon-similar",
								buttons: ["查看", "删除"],
								menu: "未支付订单",
								tableName: "orders/未支付"
							},
							{
								appFrontIcon: "cuIcon-taxi",
								buttons: ["删除", "查看"],
								menu: "已发货订单",
								tableName: "orders/已发货"
							},
							{
								appFrontIcon: "cuIcon-time",
								buttons: ["删除", "发货", "查看"],
								menu: "未发货订单",
								tableName: "orders/未发货"
							},
							{
								appFrontIcon: "cuIcon-medal",
								buttons: ["查看", "删除", "导出", "日销额", "品销额", "类销额"],
								menu: "已完成订单",
								tableName: "orders/已完成"
							}
						]
					},

					// 退款管理
					{
						menu: "退款管理",
						child: [
							{
								appFrontIcon: "cuIcon-refund",
								buttons: ["查看", "审核", "处理"],
								menu: "退款申请管理",
								tableName: "refundapplication"
							}
						]
					}
				],
				frontMenu: [],
				hasBackLogin: "是",
				hasBackRegister: "否",
				hasFrontLogin: "否",
				hasFrontRegister: "否",
				roleName: "管理员",
				tableName: "users"
			},

			// 用户角色菜单配置
			{
				backMenu: [
					// 我的收藏管理
					{
						menu: "我的收藏管理",
						child: [
							{
								appFrontIcon: "cuIcon-favor",
								buttons: ["查看", "删除"],
								menu: "我的收藏管理",
								tableName: "storeup"
							}
						]
					},
					// 药品经营资质管理
					{
						menu: "药品经营资质管理",
						child: [
							{
								appFrontIcon: "cuIcon-check",
								buttons: ["查看"],
								menu: "药品经营资质",
								tableName: "qualification"
							}
						]
					}
				],
				frontMenu: [],
				hasBackLogin: "否",
				hasBackRegister: "否",
				hasFrontLogin: "是",
				hasFrontRegister: "是",
				roleName: "用户",
				tableName: "yonghu"
			}
		];
	}
};

export default menu;
